export function getOptimizedImageLink(
  imgUrl: string,
  obj: { width?: number; height?: number; quality?: string }
) {
  const stringParams: Record<string, string> = {};

  if (obj.width !== undefined) stringParams.width = String(obj.width);
  if (obj.height !== undefined) stringParams.height = String(obj.height);
  if (obj.quality !== undefined) stringParams.quality = String(obj.quality);

  const params = new URLSearchParams(stringParams)
    .toString()
    .replaceAll('&', ',');
  const path = params ? `${params}/${imgUrl}` : '';

  return `https://elfsight.com/cdn-cgi/image/${path}`;
}
